import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import titleMixin from './mixins/titleMixin'

Vue.config.productionTip = false
Vue.mixin(titleMixin)
Vue.prototype.$getParent = function (name) {
  let p = this.$parent;
  while(typeof p !== 'undefined'){
    if(p.$options.name == name) {
      return p;
    }else {
      p = p.$parent;
    }
  }
  return false;
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
